import { FormField } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { Local, createLocalSchema, local } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { LocalForm } from '../atoms/LocalForm'

export default function AdicionarLocal() {
    const { mutateAsync, isLoading } = local.mutations.useCreate({
        invalidateQuery: true,
    })
    const empresaId = useStore(state => state.companyId)

    const handleSubmit: SubmitHandler<Local> = async data =>
        mutateAsync(
            { ...data, empresaId },
            {
                onSuccess: () => {
                    toast.success('Local adicionado com sucesso')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={createLocalSchema}
            open={hasPermission(['create', 'Locais'])}
        >
            <Dialog.Title>Adicionar Local</Dialog.Title>
            <Dialog.Content>
                <FormField name="nomeLocal" label="Nome do local" required />
                <LocalForm />
                <FormField name="latitude" hidden />
                <FormField name="longitude" hidden />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
